// API Key 下拉 — 复用 useDnsCredentials();option 文案 provider·label。
// value=credential_id('' 表未绑定);onChange 传 '' 表解绑。
import { useDnsCredentials } from '../../_lib/jumpdomain-api'

export function CredentialSelect({
  value,
  onChange,
  testid,
  disabled,
}: {
  value: string
  onChange: (credentialId: string) => void
  testid?: string
  disabled?: boolean
}) {
  const { data } = useDnsCredentials()
  const creds = data?.credentials ?? []
  return (
    <select
      className="rounded border border-gray-300 px-2 py-1 text-xs text-gray-700 disabled:opacity-50"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      data-testid={testid}
    >
      <option value="">未绑定 Key</option>
      {creds.map((c) => (
        <option key={c.id} value={c.id}>
          {c.provider}·{c.label || c.masked_token}
        </option>
      ))}
    </select>
  )
}
